<script lang="ts">
  import '$lib/styles/solutions.css';
</script>

<svelte:head>
  <title>Contact — TestMachine</title>
  <meta name="description" content="Contact TestMachine for Web3 security solutions." />
</svelte:head>

<!-- Hero -->
<section class="page-hero">
  <div class="container">
    <h1 class="page-hero-title">Contact</h1>
    <p class="page-hero-subtitle">Get in touch for Web3 security solutions.</p>
  </div>
</section>

<!-- Contact form will be ported -->
<div class="container">
  <p>Contact form and information will be ported from original...</p>
</div>

<style>
  .page-hero {
    padding: calc(var(--nav-h) + 100px) 0 80px;
    text-align: center;
  }
  .page-hero-title {
    font-family: var(--font-display);
    font-size: clamp(2.75rem, 7vw, 4.5rem);
    font-weight: 800;
    line-height: 1.06;
    letter-spacing: -0.035em;
    color: var(--fg);
    margin-bottom: 1.5rem;
  }
  .page-hero-subtitle {
    font-size: 1.25rem;
    color: var(--fg-muted);
  }
</style>